/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_No_MatchesInputs */

const en_orders_no_matches = /** @type {(inputs: Orders_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No orders match the selected day and status filters.`)
};

const es_orders_no_matches = /** @type {(inputs: Orders_No_MatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay pedidos que coincidan con el dia y estado seleccionados.`)
};

/**
* | output |
* | --- |
* | "No orders match the selected day and status filters." |
*
* @param {Orders_No_MatchesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_no_matches = /** @type {((inputs?: Orders_No_MatchesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_No_MatchesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_no_matches(inputs)
	return es_orders_no_matches(inputs)
});